import React from 'react'
import Reflux from 'reflux'
import logo from '../../images/logo.png'

class Footer extends Reflux.Component {

    constructor() {
        super()
        this.state = {}
    }

    render() {
        return (
            <section id="footer">
                <div className="container">
                    <div className="row">
                        <div className="col-md-2">
                            <img className='footer-logo img-fluid' src={logo} title="logo" alt="logo"/>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-12">
                            <p className='footer-copyright-text'>&copy; Beeker - All Rights reserved. </p>
                        </div>
                    </div>
                </div>
            </section>
        )
    }
}

export default Footer


// WEBPACK FOOTER //
// ./src/components/common/Footer.js